<template>
  <div class="p-grid dashboard">
    <div class="p-col-12">
      <Toast />

      <div class="card">
        <div class="title">Gross Profit</div>
        <DataTable
          :value="grossProfit"
          :paginator="true"
          class="p-datatable-outlets"
          :rows="20"
          data-key="doc_number"
          :rowHover="true"
          :scrollable="true"
          scrollDirection="horizontal"
        >
          <template #header>
            <div class="p-grid p-fluid p-mb-2">
              <div class="p-col">
                <Calendar
                  v-model="start_date"
                  :showIcon="true"
                  dateFormat="yy-mm-dd"
                  placeholder="Start Date"
                  :selectOtherMonths="true"
                  :showButtonBar="true"
                />
              </div>
              <div class="p-col">
                <Calendar
                  v-model="end_date"
                  :showIcon="true"
                  dateFormat="yy-mm-dd"
                  placeholder="End Date"
                  :selectOtherMonths="true"
                  :showButtonBar="true"
                />
              </div>
              <div class="p-col">
                <Button
                  label="Cari"
                  class="p-button-info"
                  @click="getGrossProfit()"
                  v-shortkey.push="['enter']"
                  @shortkey="getGrossProfit()"
                />
              </div>
              <!-- <div class="p-col">
                <router-link
                  :to="{
                    name: 'print-daily-omset',
                    query: {
                      audit_date: moment(audit_date).format('YYYY-MM-DD'),
                      outlet_id: user
                    }
                  }"
                  target="_blank"
                >
                  <Button
                    label="Print"
                    icon="pi pi-print"
                    class="p-button-success"
                  />
                </router-link>
              </div> -->
            </div>
            <table
              class="table table-responsive"
              style="font-size: 16px"
              v-if="grossProfit.length > 0"
            >
              <thead class="thead-light">
                <tr>
                  <th>Total Profit</th>
                  <th>Total Qty</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <h5>{{ total_profit | currency }}</h5>
                  </td>
                  <td>{{ total_qty }}</td>
                </tr>
              </tbody>
            </table>
          </template>
          <template #empty>Data tidak ditemukan.</template>
          <template #loading
            >Mengambil data daftar gross profit. Mohon tunggu</template
          >
          <Column
            header="Tanggal"
            headerStyle="text-align: center; width: 15rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.date }}
              </div>
            </template>
          </Column>
          <Column
            header="No Invoice"
            headerStyle="text-align: center; width: 15rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.invoice }}
              </div>
            </template>
          </Column>
          <Column header="Qty" headerStyle="text-align: center; width: 10rem">
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.qty }}
              </div>
            </template>
          </Column>
          <Column
            header="Profit"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.gross_profit | currency }}
              </div>
            </template>
          </Column>
        </DataTable>
      </div>
    </div>
  </div>
</template>

<script>
var moment = require('moment')
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['user', 'isAuthenticated'])
  },
  data() {
    return {
      moment: moment,
      today: new Date().toISOString().split('T')[0],
      loading: true,
      grossProfit: null,
      start_date: null,
      end_date: null,
      total_profit: null,
      total_qty: null
    }
  },
  mounted() {
    this.getGrossProfit()
    this.getAuthUser()
  },
  methods: {
    getAuthUser() {
      console.info(this.user)
      this.start_date = this.today
      this.end_date = this.today
    },
    getGrossProfit() {
      let start_date = this.start_date
        ? moment(this.start_date).format('YYYY-MM-DD')
        : this.today

      let end_date = this.end_date
        ? moment(this.end_date).format('YYYY-MM-DD')
        : this.today

      // validate start_date cant surpass end_date
      if (start_date > end_date) {
        this.$toast.add({
          severity: 'error',
          summary: 'Tanggal invalid',
          life: 3000
        })
        this.getAuthUser()
        this.getGrossProfit()
      } else {
        this.$http
          .get(
            `${process.env.VUE_APP_API_URL}/profit?start_date=${start_date}&end_date=${end_date}}`
          )
          .then(response => {
            if (response.status === 200) {
              this.grossProfit = response.data.data.profit
              this.total_profit = response.data.data.total_profit
              this.total_qty = response.data.data.total_qty
            }
          })
      }
    }
  }
}
</script>

<style scoped lang="scss">
/deep/ .p-progressbar {
  height: 0.5rem;
  background-color: #d8dadc;

  .p-progressbar-value {
    background-color: #607d8b;
  }
}

.qty {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 50px;
}

.p-datatable .p-column-filter {
  display: none;
}

.table-header {
  display: flex;
  justify-content: space-between;
}

/deep/ .p-datatable.p-datatable-outlets {
  .p-datatable-header {
    padding: 1rem;
    text-align: left;
    font-size: 1.5rem;
  }

  .p-paginator {
    padding: 1rem;
  }

  .p-datatable-thead > tr > th {
    text-align: left;
  }

  .p-datatable-tbody > tr > td {
    cursor: auto;
  }

  .p-dropdown-label:not(.p-placeholder) {
    text-transform: uppercase;
  }
}

/* Responsive */
.p-datatable-outlets .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}

.customer-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.status-qualified {
    background: #c8e6c9;
    color: #256029;
  }

  &.status-unqualified {
    background: #ffcdd2;
    color: #c63737;
  }

  &.status-negotiation {
    background: #feedaf;
    color: #8a5340;
  }

  &.status-new {
    background: #b3e5fc;
    color: #23547b;
  }

  &.status-renewal {
    background: #eccfff;
    color: #694382;
  }

  &.status-proposal {
    background: #ffd8b2;
    color: #805b36;
  }
}

.p-progressbar-value.ui-widget-header {
  background: #607d8b;
}

@media (max-width: 640px) {
  .p-progressbar {
    margin-top: 0.5rem;
  }
}

.product-image {
  width: 100px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.orders-subtable {
  padding: 1rem;
}

.product-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.status-instock {
    background: #c8e6c9;
    color: #256029;
  }

  &.status-outofstock {
    background: #ffcdd2;
    color: #c63737;
  }

  &.status-lowstock {
    background: #feedaf;
    color: #8a5340;
  }
}

.order-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.order-delivered {
    background: #c8e6c9;
    color: #256029;
  }

  &.order-cancelled {
    background: #ffcdd2;
    color: #c63737;
  }

  &.order-pending {
    background: #feedaf;
    color: #8a5340;
  }

  &.order-returned {
    background: #eccfff;
    color: #694382;
  }
}

@media screen and (max-width: 960px) {
  /deep/ .p-datatable {
    &.p-datatable-outlets {
      .p-datatable-thead > tr > th,
      .p-datatable-tfoot > tr > td {
        display: none !important;
      }

      .p-datatable-tbody > tr {
        > td {
          text-align: left;
          display: block;
          border: 0 none !important;
          width: 100% !important;
          float: left;
          clear: left;
          border: 0 none;

          .p-column-title {
            padding: 0.4rem;
            min-width: 30%;
            display: inline-block;
            margin: -0.4rem 1rem -0.4rem -0.4rem;
            font-weight: bold;
          }

          .p-progressbar {
            margin-top: 0.5rem;
          }
        }
      }
    }
  }
}
</style>
